import React from "react";
import TextField from "@mui/material/TextField";

export default function PriceField(props) {
  const {
    InputProps,
    label,
    name,
    onChange,
    disabled,
    value: priceVal,
    onBlur,
    ...other
  } = props;

  return (
    <TextField
      name={name}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      label={label}
      value={priceVal}
      size="small"
      color="primary"
      fullWidth
      margin="dense"
      type="number"
      InputProps={InputProps}
      onBlur={() => {
        if (onBlur) {
          onBlur();
        }
      }}
    />
  );
}
